import React from "react";
import {IconsContainer } from "../Projects/Projects.styled";
import { SkillsSectionContainer,SkillsSectionContainerWrapper } from "./Skills.styled";
import {AiOutlineHtml5} from "react-icons/ai"
import { TbBrandCss3, TbBrandNextjs } from "react-icons/tb";
import {
  SiJavascript,
  SiRedux,
  SiFirebase,
  SiStyledcomponents,
  SiTailwindcss
} from "react-icons/si";
import { FaReact, FaAngular } from "react-icons/fa";



const Skills = () => {
  return (
    <SkillsSectionContainerWrapper>
      <SkillsSectionContainer>
        <h1>Languages and Frameworks</h1>
        <div>
          <p>
            I'm proficient in HTML, CSS, JavaScript, React JS, Next JS, Tailwind
            CSS, and other modern libraries and frameworks I am very versatile
            with different technologies and I am able to adapt to new
            environment quickly.
          </p>
        </div>
      </SkillsSectionContainer>
      <IconsContainer>
        <AiOutlineHtml5 size={60} />
        <TbBrandCss3 size={60} />
        <SiJavascript size={60} />
        <FaReact size={60} />
        <SiRedux size={60} />
        <TbBrandNextjs size={60} />
        <SiFirebase size={60} />
        <SiStyledcomponents size={60} />
        <SiTailwindcss size={60} />
        <FaAngular size={60} />
      </IconsContainer>
    </SkillsSectionContainerWrapper>
  );
}



export default Skills